import React from "react";
import PaginationComp from "./pager/pagination";
import { withTranslation } from 'react-i18next';
import { hot } from "react-hot-loader/root";

const UserPictureComp = props => (
  <img
    width="30px"
    height="30px"
    src={props.picture}
    className="fitProfileImage"
  />
);
class OKRHistoryComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalItems: this.props.totalItems,
      rows: this.props.rows || []
    };
    this.viewGoal = this.viewGoal.bind(this);
  }

  getHeaders() {
    return this.props.headers;
  }

  renderHistoryRow(r) {
    return (
      <div className="okrtable-row">
        {this.getHeaders().map(field => this.renderHistoryField(r, field))}
      </div>
    );
  }

  getFieldValue(r, field) {
    const value = r[field] || "";
    if (field == "picture") {
      return <UserPictureComp key={r.id} picture={value} />;
    }
    if (field == "description") {
      const subtext = typeof r.subtext !== "undefined" ? r.subtext : "";
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: value }} />
          {subtext ? (
            <div
              className="subtext-wrapper"
              dangerouslySetInnerHTML={{ __html: subtext }}
            />
          ) : (
            ""
          )}
        </div>
      );
    }
    if (field == "link_id") {
      const goal_access = r.goal_access || false;
      return goal_access == "1" ? (
        <span
          className="goal-id-link"
          onClick={e => this.viewGoal(r, e)}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      ) : (
        value
      );
    }

    return value;
  }

  viewGoal(r, e) {
    e.preventDefault();
    if (r.goal_id) {
      viewGoalDetailsPage(undefined, { id: r.goal_id });
    }
  }

  renderHistoryField(v, field) {
    const fieldClass = field ? field.toLowerCase() : "";
    return (
      <div className={`okrtable-col okrtable-col-${fieldClass}`}>
        <div>{this.getFieldValue(v, field)}</div>
      </div>
    );
  }

  setPage(number) {
    // console.log("setPage", number);
    const params = {
      page: number,
      json: true
    };
    this.getData(params);
  }

  getData(params = {}) {
    if (Object.keys(params).length) {
      const _this = this;
      if ($("#adminAppIndex").length) {
        showLoaderWidget($("#adminAppIndex"));
      } else {
        showLoaderWidget($("#content"));
      }
      const { url } = this.props;
      const isTermSearch =
        typeof params.term !== "undefined" && params.term != null;
      $.ajax({
        url,
        type: "get",
        data: params
      })
        .done(response => {
          removeLoader();
          const rows = response.rows || [];
          const updateStates = { rows };
          if (isTermSearch) {
            updateStates.totalItems = response.totalItems;
          }
          _this.setState(updateStates);
        })
        .fail(error => {
          removeLoader();
          console.log("error");
        });
    }
  }

  searchEvent(e) {
    e.preventDefault();
    const v = e.target.value.trim();
    // console.log('v', v);
    this.getData({
      term: v,
      json: true
    });
  }

  searchBox() {
    return (
      <div className="okr-history-search-wrapper">
        <input
          type="text"
          placeholder="Search..."
          className="serach-icon"
          onChange={this.searchEvent.bind(this)}
        />
      </div>
    );
  }

  emptyContent() {
    const { t } = this.props
    return <div className="empty-content">{t('No records found.')}</div>;
  }

  render() {
    const { rows } = this.state;
    // console.log('rows', rows);
    return (
      <div className="okrs-history-wrapper wb-ghead-okr_history-wrapper">
        {this.props.showSearchBox ? this.searchBox() : ""}
        <div className="okrtable">
          {rows.length
            ? rows.map(r => this.renderHistoryRow(r))
            : this.emptyContent()}
        </div>
        <PaginationComp
          totalItems={this.state.totalItems}
          maxPageSize={this.props.maxPageSize}
          perPageItem={this.props.perPageItem}
          setPageEventHandler={this.setPage.bind(this)}
        />
      </div>
    );
  }
}

OKRHistoryComp.defaultProps = {
  headers: ["picture", "description", "date"],
  rows: [],
  showSearchBox: false,
  totalItems: 0,
  maxPageSize: 30,
  perPageItem: 10,
  url: ""
};

export default hot(withTranslation()(OKRHistoryComp));
